import Svg from '@automata/ui/src/Svg';
import { useFlag } from '@automata/utils/hooks';
import Box from '@mui/system/Box';
import { CSSProperties } from 'react';

import { MenuOptions } from './components/LabwareMenu';
import ReplanProgress from './components/ReplanProgress';
import Tooltip from './components/Tooltip';
import { TooltipContextProvider } from './components/Tooltip/context';
import Main from './Main';
import { RunVisualizationData } from './types';

export type Props = {
  runProgressData: RunVisualizationData;
  elapsedTimeSeconds?: number;
  height?: CSSProperties['height'];
  menuOptions?: MenuOptions;
  isPlanning?: boolean;
};

const RunVisualizer = ({
  runProgressData,
  elapsedTimeSeconds,
  height = 500,
  menuOptions,
  isPlanning = false,
}: Props): JSX.Element => {
  const isOverlayEnabled = useFlag('fe.replan_overlay');

  return (
    <Box width="100%">
      {isOverlayEnabled && (
        <Box height={30}>
          <ReplanProgress isPlanning={isPlanning} />
        </Box>
      )}
      <Box
        position="relative"
        width="100%"
        flex="1"
        height={height}
        style={{
          userSelect: 'none', // prevents text highlighting when brush is dragged to edge
          overflow: 'hidden', // Prevents scrollbars caused by tooltip clip/transform
        }}
      >
        <TooltipContextProvider>
          <Svg>
            <Main
              runProgressData={runProgressData}
              elapsedTimeSeconds={elapsedTimeSeconds}
              menuOptions={menuOptions}
            />
          </Svg>
          <Tooltip />
        </TooltipContextProvider>
      </Box>
    </Box>
  );
};

export default RunVisualizer;

export { default as Skeleton } from './Skeleton';
export { default as NoRunProgress } from './NoRunProgress';
export type { MenuOptions, LabwareMenuAction } from './components/LabwareMenu';
